



































































































































































































































import { Component } from 'vue-property-decorator';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Camaras/Alertas/FiltrosBusqueda.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import WidgetAlerta from '@/pantallas/Camaras/Alertas/WidgetAlerta.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { fetchReportesSerie } from './fetchReporteSerie';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import VerCrearModal from './VerCrearModal.vue';
import VerEditarModal from './VerEditarModal.vue';
import HistorialTiposProducto from './HistorialTiposProducto.vue';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import ModalImportar from './ModalImportar.vue';
import { file } from 'jszip';
@Component({
  components: {
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    FormFieldsContainer,
    DatePicker,
    VerCrearModal,
    VerEditarModal,
    HistorialTiposProducto,
    ModalImportar,
  },
})
export default class TiposProductoBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.TiposProducto;
  porductoList: any = [];
  plataformaList: any = [];
  tipoEquipoList: any = [];
  loadingService = new LoadingService();
  filtrobusquedagrilla: string = '';
  filtro: any;
  showReporteGenerado: boolean = false;
  tipoeqid: any = '';
  pagina: number = 1;
  columnApi: any = null;
  gridApi: GridApi = null;
  dialog: boolean = false;
  dialog2: boolean = false;
  texto_reporte: string = '';
  usuarioID: any = '';
  ordesList: any;
  codigoEquipo: any = '';
  showImportar: boolean = false;

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'tipoproductoid',
        field: 'tipoeqid',
        cellStyle: { textAlign: 'left' },
        lockVisible: true,
        width: 140,
        hide: true,
        minWidth: 50,
      },
      {
        headerName: 'Código Producto',
        field: 'tipoprodcod_producto',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 50,
      },
      {
        headerName: 'Código INET',
        field: 'tipoprodcod_inet',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 50,
      },
      {
        headerName: 'Descripción Corta',
        field: 'tipoproddesc_corta',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
        minWidth: 50,
      },
      {
        headerName: 'Descripción Larga',
        field: 'tipoproddesc_larga',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
        minWidth: 50,
      },
      {
        headerName: 'Nombre Producto CRM',
        field: 'tipoprodnombre_crm',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
        minWidth: 50,
      },
      {
        headerName: 'Cuenta Ingreso',
        field: 'tipoprodcuenta_ingreso',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        minWidth: 50,
      },
      {
        headerName: 'Cuenta Costo',
        field: 'tipoprodcuenta_costo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        minWidth: 50,
      },
      {
        headerName: 'Clase',
        field: 'clase',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        minWidth: 50,
      },
      {
        headerName: 'Plataforma',
        field: 'producto',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        minWidth: 50,
      },
      {
        headerName: 'Tipo de Equipo',
        field: 'tipoeqname',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        minWidth: 50,
      },
      {
        headerName: 'Estado',
        field: 'tipoprodestado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        minWidth: 50,
        cellRenderer: params => {
          if (params.data.tipoprodestado == 't') {
            return (
              '<i class="material-icons" title="Anulado" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: rgb(255, 58, 58)"></i>' +
              '<a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">' +
              'INACTIVO' +
              '</a>'
            );
          } else {
            return (
              '<i class="material-icons" title="Vigente" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: #26FF26"></i>' +
              '<a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">' +
              'ACTIVO' +
              '</a>'
            );
          }
        },
      },
      {
        headerName: 'Visible Cotizador',
        field: 'visible_cotizador',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        minWidth: 50,
        cellRenderer: params => {
          if (params.data.visible_cotizador == 'f') {
            return (
              '<i class="material-icons" title="NO VISIBLE" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: rgb(255, 58, 58)"></i>' +
              '<a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">' +
              'NO VISIBLE' +
              '</a>'
            );
          } else {
            return (
              '<i class="material-icons" title="VISIBLE" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: #26FF26"></i>' +
              '<a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">' +
              'VISIBLE' +
              '</a>'
            );
          }
        },
      },
      {
        headerName: 'Glosa',
        field: 'tipoprodglosa',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        minWidth: 50,
      },
      {
        headerName: 'Link',
        field: 'tipoprodlink',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        minWidth: 50,
      },
      {
        headerName: 'Precio de Instalación',
        field: 'tipoprodprecio_instala',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        minWidth: 50,
        cellRenderer: params =>
          params.data.tipoprodprecio_instala != '0'
            ? params.data.tipoprodprecio_instala
            : null,
      },
      {
        headerName: 'Precio de Monitoreo',
        field: 'tipoprodprecio_monitoreo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        minWidth: 50,
        cellRenderer: params =>
          params.data.tipoprodprecio_monitoreo != '0'
            ? params.data.tipoprodprecio_monitoreo
            : null,
      },
      {
        headerName: 'Precio de Equipo',
        field: 'tipoprodprecio_equipo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        minWidth: 50,
        cellRenderer: params =>
          params.data.tipoprodprecio_equipo != '0'
            ? params.data.tipoprodprecio_equipo
            : null,
      },
      {
        headerName: 'Precio de Arriendo',
        field: 'tipoprodprecio_arriendo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        minWidth: 50,
        cellRenderer: params =>
          params.data.tipoprodprecio_arriendo != '0'
            ? params.data.tipoprodprecio_arriendo
            : null,
      },
    ],

    pagination: true,
    paginationPageSize: 25,
    onGridReady: this.handleGridReady,
  };

  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { '': '' },
      'conecta_matriz_producto_comercial/get_grilla_filters'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.porductoList = data.data.PRODUCTO;
          self.plataformaList = data.data.PLATAFORMA;
          self.tipoEquipoList = data.data.TIPO_EQUIPO;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió Un Error Al Cargar Los Filtros', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async handleGridReady(event: GridReadyEvent) {
    this.usuarioID = JSON.parse(localStorage.getItem('user')).id;
    this.ordesList = await this.getReportes(this.usuarioID);
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
    this.getEquipos();
    this.clearFilters();
  }

  async getReportes(usuarioID: any) {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { usuarioID: usuarioID },
      'conecta_matriz_producto_comercial'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió Un Error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  formFields: FormFieldDefMap = {
    codigo_producto: {
      label: 'Código Producto',
      id: '',
      value: '',
    },
    plataforma: {
      label: 'Plataforma',
      id: '',
      value: '',
    },
    producto: {
      label: 'Clase Producto',
      id: '',
      value: '',
    },
    tipoequipo: {
      label: 'Tipo de Equipo',
      id: '',
      value: '',
    },
    visible_cotizador: {
      label: 'Visible Cotizador',
      id: '',
      value: '',
    },
    estado: {
      label: 'Estado',
      id: '',
      value: '',
    },
  };

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }
  searchData() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }
  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }
  get fechaMinimaInicio() {
    let fechaIni = this.formFields.fechaInicio.value;
    return fechaIni as moment.Moment;
  }
  get fechaMinima() {
    let fechaMin = moment(new Date())
      .add(-12, 'months')
      .toISOString()
      .substr(0, 10);
    return fechaMin;
  }
  get fechaMaximaInicio() {
    //let fechaMax = this.formFields.fechaInicio.value;

    return moment(this.fechaMaxima) as moment.Moment;
    //return fechaMax as moment.Moment;
  }
  async clearFilters() {
    this.formFields.plataforma.value = undefined;
    this.formFields.producto.value = undefined;
    this.formFields.tipoequipo.value = undefined;
    this.formFields.visible_cotizador.value = undefined;
    this.formFields.codigo_producto.value = undefined;
    this.formFields.estado.value = undefined;

    this.ordesList = await this.getReportes(this.usuarioID);
    this.gridApi.setRowData(this.ordesList);
  }

  //evita el click derecho
  handlerContexTmenu(e: any) {
    e.preventDefault();
  }

  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };
  accionEditar: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };
  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: false,
  };
  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionEditar,
    this.accionExportar,
  ];
  constructor() {
    super();
    actionsEvent.onEditar(this.handleEditarClick);
    actionsEvent.onVerHistorico(this.handleHistoricoClick);
  }

  handleEditarClick(params: ICellRendererParams) {
    this.codigoEquipo = params.data;
    this.dialog2 = true;
  }

  selectedCodigo: any;
  selectedNombre: any;
  ShowHistorico: boolean = false;
  handleHistoricoClick(params: ICellRendererParams) {
    this.ShowHistorico = true;
    this.selectedCodigo = params.data.tipoprodcod_producto;
    this.selectedNombre = params.data.tipoeqname;
  }

  async handleBuscarClick() {
    let self = this;
    this.loadingService.showLoading();
    if (self.formFields.codigo_producto.value == undefined) {
      self.formFields.codigo_producto.value = '';
    }
    if (self.formFields.plataforma.value == undefined) {
      self.formFields.plataforma.value = '';
    }
    if (self.formFields.producto.value == undefined) {
      self.formFields.producto.value = '';
    }
    if (self.formFields.tipoequipo.value == undefined) {
      self.formFields.tipoequipo.value = '';
    }
    if (self.formFields.estado.value == undefined) {
      self.formFields.estado.value = '';
    }
    if (self.formFields.visible_cotizador.value == undefined) {
      self.formFields.visible_cotizador.value = '';
    }
    return fetchReportesSerie(
      {
        CODIGO_PRODUCTO: self.formFields.codigo_producto.value,
        PLATAFORMA: self.formFields.plataforma.value,
        PRODUCTO: self.formFields.producto.value,
        EQUIPO: self.formFields.tipoequipo.value,
        ESTADO: self.formFields.estado.value,
        VISIBLE_COTIZADOR: self.formFields.visible_cotizador.value,
      },
      'conecta_matriz_producto_comercial/get_filtered_rs'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.gridApi.setRowData(data.data.data.LISTA);
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.gridApi.setRowData((this.ordesList = []));
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió Un Error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  crear_equipo() {
    this.dialog = true;
  }
  async btn_exportar() {
    let body: any = this.filtros2body();
    body.extension = 'csv';
    this.loadingService.showLoading(undefined, 'btn_exportar');
    return fetchReportesSerie(
      {
        body: body,
        clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
        user_id: JSON.parse(localStorage.getItem('user')).id,
        tipo_alerta: 'Reporte Tipo de Producto',
      },
      'conecta_matriz_producto_comercial/exportar'
    )
      .then((data: any) => {
        this.showReporteGenerado = true;
        this.loadingService.hideLoading('btn_exportar');

        this.texto_reporte = data.data.MENSAJE_RESPUESTA;

        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }
  filtros2body() {
    let body: any = {};
    if (this.formFields.codigo_producto.value == undefined) {
      this.formFields.codigo_producto.value = '';
    }
    if (this.formFields.plataforma.value == undefined) {
      this.formFields.plataforma.value = '';
    }
    if (this.formFields.producto.value == undefined) {
      this.formFields.producto.value = '';
    }
    if (this.formFields.tipoequipo.value == undefined) {
      this.formFields.tipoequipo.value = '';
    }
    body.CODIGO_PRODUCTO = this.formFields.codigo_producto.value
      ? this.formFields.codigo_producto.value
      : '';
    body.plataforma = this.formFields.plataforma.value
      ? this.formFields.plataforma.value
      : '';
    body.producto = this.formFields.producto.value
      ? this.formFields.producto.value
      : '';
    body.equipo = this.formFields.tipoequipo.value
      ? this.formFields.tipoequipo.value
      : '';
    body.ESTADO = this.formFields.estado.value
      ? this.formFields.estado.value
      : '';
    body.VISIBLE_COTIZADOR = this.formFields.visible_cotizador.value
      ? this.formFields.visible_cotizador.value
      : '';

    return body;
  }
  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }
  abrirModalImportar() {
    this.showImportar = true;
  }
  async handleCierreModalCrear() {
    this.ordesList = await this.getReportes(this.usuarioID);
    this.gridApi.setRowData(this.ordesList);
    this.dialog = false;
    this.dialog2 = false;
    this.ShowHistorico = false;
    this.showImportar = false;
  }
  async handleCierreModalimportar(id_reporte: string) {
    this.texto_reporte = id_reporte;
    await this.handleCierreModalCrear();
    this.showReporteGenerado = true;
  }
  async generarReporte(data: any, filename: any) {
    console.log('fileData ', filename);
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      {
        user_id: JSON.parse(window.localStorage.user).id,
        clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
        excel: data,
        filename: filename,
      },
      'conecta_matriz_producto_comercial/process_excel'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.texto_reporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al importar excel', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
}
